<template>
  <div>
     <mdb-row>
       <mdb-col md="2">
        <vertical-list :titles="routes.titles" :active="current" @select-item="onSelectItem"/>
       </mdb-col>
       <mdb-col md="10">
         <router-view/>
       </mdb-col>
     </mdb-row>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import FolderLabel from '@/components/common/FolderLabel.vue';
import VerticalList from '../../../components/common/VerticalList.vue';
export default {
  components: { VerticalList },
  name: 'StudentTestPage',
  props: [],
  data: () => ({
    routes: {
      titles: ['사전 자가진단', '사전 필답평가', '성취도 평가'],
      comps: ['StudentPrediag', 'StudentPreTest', 'StudentTestSummaryPage']
    }
  }),
  computed: {
    current () {
      const name = this.$route.name
      const ix = this.routes.comps.findIndex(c => c === name)
      return ix === -1 ? 2 : ix
    }
  },
  methods: {
    onSelectItem (index) {
      const name = this.routes.comps[index]
      this.$router.push({ name, query: this.$route.query })
    }
  }
}
</script>
